﻿$.fn.dxCtrlGestionDestinataire = function custom_dxCtrlGestionDestinataire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlgestiondestinataire dx-ctrl");
        this.createInstance(new cdxCtrlGestionDestinataire(this, option));
    }
    return this;
}

window.cdxCtrlGestionDestinataire = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    //option.type
    var lstDestCom = null

    var jauge = $("<div/>").appendTo(container.closest(".divcadre")).dxCtrlJauge({}).dxCtrlJauge("instance")
    var $DivConfigEnvoi = null
    function mConstruit() {
        //container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty();
        container.css("max-width", "650px");

        var data = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.id_table_com).nom, option.id_com).data
        $("<div style='height:100%'/>").appendTo(container).dxCtrlContentEnvoiMailing({
            bddCtrl: option.bddCtrl,
            data: data,
            allowModifDest: true,
            onDemandeEnvoi:option.onDemandeEnvoi
        })

        //var $Div = $("<div style='font-size:200%;font-weight:bold;padding:15px;text-align:center;'>Gestion des destinataires" + ((typeof option.onDemandeEnvoi != 'undefined') ? " et envoi" : "") + "</div>").appendTo(container)

        //jauge.mShow()
        //option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: option.id_table_com, id_com: option.id_com, type: option.type }, function (data) {
        //    if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []

        //    lstDestCom = data.lst_com_destinataire
        //    var lstIdentique = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstIdentique(lstDestCom)
        //    var lstSansAdresse = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstSansAdresse(lstDestCom)
        //    var lstDoublon = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstDoublon(lstDestCom)
        //    var lstIndirect = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstIndirect(lstDestCom)
        //    var lstHardBounce = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstHardBounce(lstDestCom)
        //    var lstSoftBounce = option.bddCtrl.getObjet("com_destinataire").objetMetier.mGetLstSoftBounce(lstDestCom)

        //    var $DivGestDest = $("<div style='border:1px solid black;padding:20px;border-radius:10px;background-color:" + theme.backgroundcolorTooltip + ";'/>").appendTo(container)

        //    var $DivNb = $("<div style='padding:0 15px 15px 15px;text-align:center;'/>").appendTo($DivGestDest)
        //    var $Table = $("<table style='display:inline-block;'/>").appendTo($DivNb)
        //    var $Tr = $("<tr/>").appendTo($Table)
        //    var $Td = $("<td style='width:1px;white-space:nowrap;font-family:Barlow Condensed;font-size:500%;padding-right:5px;'>" + lstDestCom.length + "</td>").appendTo($Tr)
        //    var $Td = $("<td style='width:1px;white-space:nowrap;vertical-align:middle;text-align:left;'>destinataires<br/>pour votre " + ((option.type == "email") ? "email" : ((option.type == "mobile") ? "sms" : "document")) + "</td>").appendTo($Tr)

        //    if (lstIdentique.length == 0 && lstSansAdresse.length == 0 && lstDoublon.length == 0 && lstIndirect.length == 0 && lstHardBounce.length == 0 && lstSoftBounce.length == 0) {
        //        $DivNb.css("padding-bottom", "0")
        //        $("<div style='text-align:center;padding-bottom:15px;'>Tous vos destinataires sont cohérents</div>").appendTo($DivGestDest)
        //    } else {
        //        var typeData = ((option.type == "email") ? "comdestgestemail" : ((option.type == "mobile") ? "comdestgestsms" : "comdestgestcourrier"))
        //        var $Table = $("<table style='width:100%;'/>").appendTo($DivGestDest)

        //        //destinataire sans adresse
        //        if (lstSansAdresse.length > 0) {
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstSansAdresse.length == 0) ? "color:green;" : "color:red;") + "'>" + lstSansAdresse.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            var precision = "<br/><i style='font-size:80%;'>A l'envoi, ces destinataires sont automatiquement supprimés de l'envoi.</i>"
        //            if (option.type == "email") { $Td.html("<b style='font-size:120%;'>Destinataires sans adresse email</b>" + precision) }
        //            else { $Td.html("<b style='font-size:120%;'>Destinataires sans téléphone mobile</b>" + precision) }
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Supprimer tous les destinataires<br/>sans " + ((option.type == "email") ? "adresse email" : "téléphone mobile"),
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieSansAdresse(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length>0) ? ",": "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlButton({
        //                text: "Modifier",
        //                width: "100%",
        //                txtTooltip: "Saisir " + ((option.type == "email") ? "une adresse email" : "un téléphone mobile") + "<br/>pour les destinataires sans " + ((option.type == "email") ? "adresse email" : "téléphone mobile"),
        //                onClick: function (e) {
        //                    //(typeData, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText)
        //                    option.onDemandeList(typeData,"sansadresse", lstSansAdresse, false,
        //                        "Correction des destinataires sans " + ((option.type == "email") ? "adresse email" : "numéro de mobile"),
        //                        "Supprimer les destinataires sans " + ((option.type == "email") ? "adresse" : "téléphone") + " ou saisissez " + ((option.type == "email") ? "une adresse email" : "un téléphone mobile"),
        //                        "Aucun destinataire sans " + ((option.type == "email") ? "adresse email" : "sans téléphone"),
        //                        "Ce destinataire ne dispose pas " + ((option.type == "email") ? "d'adresse email, saisissez en une..." : "de téléphone mobile, saisissez en un..."))
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }

        //        //destinataire identique
        //        if (lstIdentique.length > 0) {
        //            //var $Tr = $("<tr/>").appendTo($Table)
        //            //var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstIdentique.length == 0) ? "color:green;" : "color:red;") + "'>" + lstIdentique.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            $Td.html("<b style='font-size:120%;'>Destinataires identiques</b><br/><i style='font-size:80%;'>Des contacts sont spécifiés plusieurs fois dans la liste de vos destinataires<br/>A l'envoi, ces destinataires sont automatiquement nettoyé pour n'en garder qu'un seul par destinataire identique.</i></b>")
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Garder un seul destinataire<br/>par destinataire identique",
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieIdentique(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }

        //        //if (option.type == "email") {
        //        //destinataire indirecte
        //        if (lstIndirect.length > 0) {
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstIndirect.length == 0) ? "color:green;" : "color:orange;") + "'>" + lstIndirect.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            $Td.html("<b style='font-size:120%;'>Destinataires indirectes</b><br/><i style='font-size:80%;'>Vous écrivez à un contact dans une structure sur l'adresse directe de cette structure</i>")
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Supprimer les destinataires indirectes",
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieIndirect(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlButton({
        //                text: "Modifier",
        //                width: "100%",
        //                txtTooltip: "Saisir une adresse email<br/>pour les destinataires indirectes",
        //                onClick: function (e) {
        //                    //(typeData, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText)
        //                    option.onDemandeList(typeData,"indirect", lstIndirect, false,
        //                        "Saisie " + ((option.type == "email") ? "d'un email" : "d'un numéro de mobile") + " pour les destinataires indirectes",
        //                        "Actuellement, ces destinataires recoivent un " + ((option.type == "email") ? "email" : "sms") + " sur " + ((option.type == "email") ? "l'adresse email" : "le mobile") + " définie sur leur structure car ils n'ont pas " + ((option.type == "email") ? "d'adresse email" : "de numéro de mobile") + " directe saisie.",
        //                        "Aucun destinataire indirecte",
        //                        "Ce contact a " + ((option.type == "email") ? "une adresse email indirecte (celle de sa structure), saisissez en une directe pour lui dans la structures..." : "un téléphone mobile indirecte (celui de la structure), saisissez en un direct pour lui dans la structure..."))
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }

        //        //destinataire en doublon mail ou tel
        //        if (lstDoublon.length > 0) {
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstDoublon.length == 0) ? "color:green;" : "color:red;") + "'>" + lstDoublon.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            var precision = "<br/><i style='font-size:80%;'>A l'envoi, ces destinataires sont automatiquement nettoyés pour n'en garder qu'un seul par " + ((option.type == "email") ? "adresse email" : "numéro de téléphone") + " identique.</i>"
        //            if (option.type == "email") { $Td.html("<b style='font-size:120%;'>Destinataires en doublon d'adresse email</b>" + precision) }
        //            else { $Td.html("<b style='font-size:120%;'>Destinataires en doublon de téléphone mobile</b>" + precision) }
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Supprimer les doublons<br/>en choisissant aux hasard un des doublons<br/>et en supprimant les autres destinataires",
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieDoublon(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlButton({
        //                text: "Modifier",
        //                width: "100%",
        //                txtTooltip: "Modifier " + ((option.type == "email") ? "l'adresse email" : "le téléphone mobile") + "<br/>pour les destinataires en doublon",
        //                onClick: function (e) {
        //                    //(typeData, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText)
        //                    option.onDemandeList(typeData,"doublon", lstDoublon, true,
        //                        "Correction des destinataires en doublon " + ((option.type == "email") ? "d'adresse email" : "de numéro de mobile"),
        //                        "Supprimer les doublons ou modifier leur " + ((option.type == "email") ? "adresse email" : "téléphone mobile"),
        //                        "Aucun destinataire en doublon " + ((option.type == "email") ? "d'adresse email" : "de mobile"),
        //                        "Ce destinataire à " + ((option.type == "email") ? "une adresse email en doublon, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en doublon, saisissez un autre numéro pour le contact..."))
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }

        //        //hard bounce
        //        if (lstHardBounce.length > 0) {
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstHardBounce.length == 0) ? "color:green;" : "color:red;") + "'>" + lstHardBounce.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            $Td.html("<b style='font-size:120%;'>Destinataires en hard-bounce</b><br/><i style='font-size:80%;'>Vous ne pouvez pas envoyer d'email sur ces adresses dans le cadre d'un emailing. Ces destinataires seront automatiquement retirer de votre emailing.</i>")
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Supprimer tous les destinataires en hard-bounce",
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieHardBounce(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlButton({
        //                text: "Modifier",
        //                width: "100%",
        //                txtTooltip: "Modifier " + ((option.type == "email") ? "les adresses emails":"les numéros de téléphones mobiles") + "<br/>qui sont en hard-bounce",
        //                onClick: function (e) {
        //                    //(typeData, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText)
        //                    option.onDemandeList(typeData,"hardbounce", lstHardBounce, false,
        //                        "Corriger les adresse en hard-bounce",
        //                        "Vous pouvez supprimer le destinataire ou modifier son adresse email en hard-bounce (qui n'existe pas)",
        //                        "Aucun destinataire en hard-bounce",
        //                        "Ce destinataire à " + ((option.type == "email") ? "une adresse email en hard-bounce, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en hard-bounce, saisissez un autre numéro pour le contact..."))
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }

        //        //soft bounce
        //        if (lstSoftBounce.length > 0) {
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td style='white-space:nowrap;font-size:400%;padding:10px;text-align:right;vertical-align:top;line-height:0.4;font-family:Barlow Condensed;" + ((lstSoftBounce.length == 0) ? "color:green;" : "color:red;") + "'>" + lstSoftBounce.length + "</td>").appendTo($Tr)
        //            var $Td = $("<td style='vertical-align:top;line-height:1;'/>").appendTo($Tr)
        //            $Td.html("<b style='font-size:120%;'>Destinataires en soft-bounce</b><br/><i style='font-size:80%;'>Vous ne pouvez pas envoyer d'email sur ces adresses dans le cadre d'un emailing. Ces destinataires seront automatiquement retirer de votre emailing.</i>")
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer",
        //                width: "100%",
        //                txtTooltip: "Supprimer tous les destinataires en soft-bounce",
        //                onClick: function (e) {
        //                    jauge.mShow()
        //                    window.setTimeout(function () {
        //                        var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieSoftBounce(lstDestCom)
        //                        var lstid = ""
        //                        lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                        option.bddCtrl.mAjaxCall({
        //                            command: "deletecomdestgroup",
        //                            lstid: lstid
        //                        }, function (data) {
        //                            mConstruit()
        //                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                        })
        //                    }, 0)
        //                }
        //            })
        //            $("<div style='padding-top:5px;'/>").appendTo($Td).dxCtrlButton({
        //                text: "Modifier",
        //                width: "100%",
        //                txtTooltip: "Modifier " + ((option.type == "email") ? "les adresses emails" : "les numéros de téléphones mobiles") + "<br/>qui sont en soft-bounce",
        //                onClick: function (e) {
        //                    //(typeData, lstIdTableIdInclu, isDoublon, title, sstitle, noDataText)
        //                    option.onDemandeList(typeData,"softbounce", lstSoftBounce, false,
        //                        "Corriger les adresse en soft-bounce",
        //                        "Vous pouvez supprimer le destinataire ou modifier son adresse email en soft-bounce (adresse inopérante)",
        //                        "Aucun destinataire en soft-bounce",
        //                        "Ce destinataire à " + ((option.type == "email") ? "une adresse email en soft-bounce, saisissez une autre adresse pour le destinataire..." : "un téléphone mobile en soft-bounce, saisissez un autre numéro pour le contact..."))
        //                }
        //            })
        //            var $Tr = $("<tr/>").appendTo($Table)
        //            var $Td = $("<td colspan='3'><hr style='opacity:0.3;'/></td>").appendTo($Tr)
        //        }
        //        //}

        //        if (lstIdentique.length > 0 || lstSansAdresse.length > 0 || lstHardBounce.length > 0 || lstSoftBounce.length > 0) {
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                text: "Nettoyer tout automatiquement",
        //                width: "100%",
        //                txtTooltip: "Supprime automatiquement tous les destinataires<br/>qui ne peuvent recevoir votre message",
        //                onClick: function (e) {
        //                    mNettoieTout()
        //                    //jauge.mShow()
        //                    //window.setTimeout(function () {
        //                    //    var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieAll(lstDestCom)
        //                    //    var lstid = ""
        //                    //    lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
        //                    //    option.bddCtrl.mAjaxCall({
        //                    //        command: "deletecomdestgroup",
        //                    //        lstid: lstid
        //                    //    }, function (data) {
        //                    //        mConstruit()
        //                    //        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                    //    })
        //                    //}, 0)

        //                    ////jaugeDemarrage.mShow()
        //                    ////var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieAll(lstDestCom)
        //                    ////var objets = option.bddCtrl.getObjets()
        //                    ////objets.mAddData(lstToDel, "suppdef")
        //                    ////objets.mSave(function (data) {
        //                    ////    mConstruit()
        //                    ////    jaugeDemarrage.mHide()
        //                    ////    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //                    ////})
        //                }
        //            })
        //        }

        //    }


        //    $DivConfigEnvoi = $("<div/>").appendTo(container)
        //    mConstruitEnvoi()

        //})

        //container.css("height", "")
    }

    function mNettoieTout() {
        jauge.mShow()
        window.setTimeout(function () {
            var lstToDel = option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieAll(lstDestCom)
            var lstid = ""
            lstToDel.forEach(function (comdest) { lstid += ((lstid.length > 0) ? "," : "") + comdest.id_com_destinataire })
            option.bddCtrl.mAjaxCall({
                command: "deletecomdestgroup",
                lstid: lstid
            }, function (data) {
                mConstruit()
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            })
        }, 100)
    }

    function mConstruitEnvoi() {
        $DivConfigEnvoi.css("height", (($DivConfigEnvoi.innerHeight() == 0) ? "" : $DivConfigEnvoi.innerHeight() + 'px'))
        $DivConfigEnvoi.empty()
        if (typeof option.onDemandeEnvoi != 'undefined') {
            var copyLstDestCom = JSON.parse(JSON.stringify(lstDestCom))
            option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieAll(copyLstDestCom)
            $("<div style='padding-bottom:20px;'/>").appendTo(container).dxCtrlConfigEnvoi({
                bddCtrl: option.bddCtrl,
                type: option.type,
                data: option.data,
                lstDesComSource: lstDestCom,
                lstDestComNettoye: copyLstDestCom,
                onDemandeEnvoi: option.onDemandeEnvoi,
                onDemandeNettoie: function () {
                    mNettoieTout()
                },
                onDemandeReload: function () { mConstruit() }
            })
        }
        $DivConfigEnvoi.css("height", "")
        jauge.mHide()
    }

    //function mNettoieDoublon(lstDestComLocal, lstToDel) {
    //    var lstDoublon = lstDestCom.filter(function (o) {
    //        return o.coord.length > 0 && lstDestCom.filter(function (o2) { return o.coord == o2.coord }).length > 1 && !lstIdentique.contains(o)
    //    })
    //    while (lstDoublon.length > 0) {
    //        lstToDel.push(lstDoublon[0])
    //        lstDestComLocal.splice(lstDestComLocal.indexOf(lstDoublon[0]), 1)
    //        lstDoublon = lstDestCom.filter(function (o) {
    //            return o.coord.length > 0 && lstDestCom.filter(function (o2) { return o.coord == o2.coord }).length > 1 && !lstIdentique.contains(o)
    //        })
    //    }
    //}
    //function mNettoieIdentique(lstDestComLocal, lstToDel) {
    //    var lstIdentique = lstDestComLocal.filter(function (o) {
    //        return lstDestComLocal.filter(function (o2) {
    //            return o.id_table_destinataire == o2.id_table_destinataire && o.id_destinataire == o2.id_destinataire
    //        }).length > 1
    //    })
    //    while (lstIdentique.length > 0) {
    //        var lstCci = lstIdentique.filter(function (o) { return o.id_type_destinataire == 3 })
    //        if (lstCci.length > 0) {
    //            lstToDel.push(lstCci[0])
    //            lstDestComLocal.splice(lstDestComLocal.indexOf(lstCci[0]), 1)
    //        } else {
    //            var lstCcc = lstIdentique.filter(function (o) { return o.id_type_destinataire == 2 })
    //            if (lstCcc.length > 0) {
    //                lstToDel.push(lstCcc[0])
    //                lstDestComLocal.splice(lstDestComLocal.indexOf(lstCcc[0]), 1)
    //            } else {
    //                var lstA = lstIdentique.filter(function (o) { return o.id_type_destinataire == 1 })
    //                if (lstA.length > 0) {
    //                    lstToDel.push(lstA[0])
    //                    lstDestComLocal.splice(lstDestComLocal.indexOf(lstA[0]), 1)
    //                }
    //            }
    //        }
    //        lstIdentique = lstDestComLocal.filter(function (o) {
    //            return lstDestComLocal.filter(function (o2) {
    //                return o.id_table_destinataire == o2.id_table_destinataire && o.id_destinataire == o2.id_destinataire
    //            }).length > 1
    //        })
    //    }
    //}
    //function mNettoieSansAdresse(lstDestComLocal, lstToDel) {
    //    var lstSansAdresse = lstDestComLocal.filter(function (o) { return o.coord.length == 0 })
    //    lstSansAdresse.forEach(function (o) {
    //        lstToDel.push(o)
    //        lstDestComLocal.splice(o, 1)
    //    })
    //}
    //function mNettoieHardBounce(lstDestComLocal, lstToDel) {
    //    var lstHardBounce = lstDestComLocal.filter(function (o) { return o.hard_bounce == 1 })
    //    lstHardBounce.forEach(function (o) { lstToDel.push(o) })
    //}
    //function mNettoieSoftBounce(lstDestComLocal, lstToDel) {
    //    var lstSoftBounce = lstDestComLocal.filter(function (o) { return o.soft_bounce == 1 })
    //    lstSoftBounce.forEach(function (o) { lstToDel.push(o) })
    //}

    //function mGetCopyLstDestComApresNettoyage() {
    //    var lstDestComLocal = JSON.parse(JSON.stringify(lstDestCom))
    //    var lstToDel = []
    //    mNettoieIdentique(lstDestComLocal, lstToDel)
    //    mNettoieSansAdresse(lstDestComLocal, lstToDel)
    //    mNettoieHardBounce(lstDestComLocal, lstToDel)
    //    mNettoieSoftBounce(lstDestComLocal, lstToDel)
    //    return lstDestComLocal
    //}

    this.element = function () { return container }

    mConstruit();
}